module.exports = __webpack_public_path__ + "static/media/corporate-subhi.e505d745.webp";